import Payments from './Payments';

export default class FreePayment extends Payments {
  createPayment() {
    var FormData = require('form-data');
    var formData = new FormData();

    formData.append('IdCart', this.cart?.IdCart);
    formData.append('TotalToPayTaxIncl', this.cart?.Total?.ToPay?.TaxIncl);
    formData.append('CurrencyIsoCode', this.cart?.Currency?.IsoCode);

    return this.http.API_AUTH.post('/payment/digipart/create', formData)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }
}
